/* tslint:disable */

declare var Object: any;
export interface StoragePostInterface {
  "id"?: number;
}

export class StoragePost implements StoragePostInterface {
  "id": number;
  constructor(data?: StoragePostInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StoragePost`.
   */
  public static getModelName() {
    return "StoragePost";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StoragePost for dynamic purposes.
  **/
  public static factory(data: StoragePostInterface): StoragePost{
    return new StoragePost(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StoragePost',
      plural: 'StoragePosts',
      path: 'StoragePosts',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StoragePost.ts